import React from "react";
import { Helmet } from "react-helmet";
import ListrikImage from "../../../assets/images/activity/listrik.jpeg";
import ListrikImage2 from "../../../assets/images/activity/listrik2.jpeg";
import ListrikImage3 from "../../../assets/images/activity/listrik3.jpeg";
import PipaImage from "../../../assets/images/activity/pipa_air.jpeg";
import PipaImage2 from "../../../assets/images/activity/pipa_air2.jpeg";
import PipaImage3 from "../../../assets/images/activity/pipa_air3.jpeg";
import ACImage from "../../../assets/images/activity/service_ac.jpeg";
import ACImage2 from "../../../assets/images/activity/service_ac2.jpeg";
import ACImage3 from "../../../assets/images/activity/service_ac3.jpeg";
import ACImage4 from "../../../assets/images/activity/service_ac4.jpeg";

import MesinImage from "../../../assets/images/activity/mesin.jpeg";

import MesinImage2 from "../../../assets/images/activity/mesin2.jpeg";

import MesinImage3 from "../../../assets/images/activity/mesin3.jpeg";
import GWTImage from "../../../assets/images/activity/gwt.jpeg";
import GWTImage2 from "../../../assets/images/activity/gwt2.jpeg";
import SaleImage from "../../../assets/images/activity/sale.jpeg";

import SaleImage2 from "../../../assets/images/activity/sale2.jpeg";

// import styles
import "./Services.css";

function Services() {
  return (
    <div>
      {/* helmet - start */}
      <Helmet>
        <title>Jelajahi Layanan Kami - Pelayanan Kami</title>
        <meta
          name="description"
          content="Pemasangan AC, isi freon, tukar tambah AC baru/bekas, service AC, wiring panel, penarikan kabel baru, perbaikan listrik yang korslet, desain kelistrikan hunian, service closet, service urinoir, instalasi air, STP dan WTP, service mesin pompa air, service kipas angin, service mesin cuci, service Kulkas, jual beli AC baru dan bekas, jual beli sparepart AC, jual beli Peralatan rumah tangga, sewa AC standing, sewa sound system, sewa peralatan untuk acara pernikahan atau ulang tahun."
        />
      </Helmet>
      {/* helmet - end */}

      {/* sercive component - start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-4">
            {/* card - air conditioner - start */}
            <div
              className="col-lg-4 col-md-6 service-item-top wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="overflow-hidden">
                {/* Image Carousel Start */}
                <div
                  id="carouselAC"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={ACImage}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Service AC 1"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={ACImage2}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Service AC 2"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={ACImage3}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Service AC 3"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={ACImage4}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Service AC 4"
                      />
                    </div>
                  </div>

                  {/* Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselAC"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselAC"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
                {/* Image Carousel End */}
              </div>

              <div className="flex-column bg-light p-4">
                <h5 className="text-center mb-3">AC (Air Conditioner)</h5>
                <div>
                  <p>
                    Butuh jasa service HVAC yang amanah dan terpercaya? Kami
                    melayani perawatan dan perbaikan System HVAC untuk rumah,
                    kost, kantor, Gedung, dan tempat usaha.
                  </p>

                  {/* list - start */}
                  <div className="mt-1 ps-4">
                    <p className="mb-1">
                      <strong>Layanan meleputi:</strong>
                    </p>
                    <ul>
                      <li>Bongkar pasang AC</li>
                      <li>Isi/tambah Freon</li>
                      <li>Service AC</li>
                      <li>Perbaikan AC tidak dingin</li>
                      <li>Pemasangan Water Heater</li>
                      <li>Pemasangan Ducting</li>
                      <li>
                        Pengecekan menyeluruh system Heating, Ventilation, and
                        Air Conditioning
                      </li>
                    </ul>
                  </div>
                  {/* list - end */}
                </div>
              </div>
            </div>
            {/* card - air conditioner - end */}

            {/* card - electrical repair - start */}
            <div
              className="col-lg-4 col-md-6 service-item-top wow fadeInUp"
              data-wow-delay="0.3s"
            >
              {/* images - start */}
              <div className="overflow-hidden">
                <div
                  id="carouselElectric"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={ListrikImage}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Wiring Panel"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={ListrikImage2}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Perbaikan Listrik"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={ListrikImage3}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Instalasi Kabel"
                      />
                    </div>
                  </div>

                  {/* Navigation Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselElectric"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselElectric"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              {/* images - end */}

              <div className="flex-column align-items-center justify-content-between bg-light p-4">
                <h5 className="mb-3 text-center">Kelistrikan</h5>
                <div>
                  <p>
                    Kami menyediakan jasa instalasi listrik, perbaikan, dan
                    perawatan jaringan listrik untuk berbagai kebutuhan, mulai
                    dari rumah tinggal, toko, kantor, hingga bangunan komersial.
                  </p>

                  {/* list - start */}
                  <div className="mt-1 ps-4">
                    <p className="mb-1">
                      <strong>Layanan meleputi:</strong>
                    </p>
                    <ul>
                      <li>Instalasi listrik baru</li>
                      <li>Perawatan Trafo dan Panel LVMDP</li>
                      <li>Perbaikan arus pendek / konslet</li>
                      <li>Pemasangan/Perakitan panel listrik</li>
                      <li>Pembuatan Single line instalasi</li>
                      <li>Pemeriksaan keamanan instalasi</li>
                      <li>Pemasangan Grounding System</li>
                      <li>System Safety Penangkal Petir</li>
                    </ul>
                  </div>
                  {/* list - end */}
                </div>
              </div>
            </div>
            {/* card - electrical repair - end */}

            {/* card - cleaning gwt - start */}
            <div
              className="col-lg-4 col-md-6 service-item-top wow fadeInUp"
              data-wow-delay="0.3s"
            >
              {/* images - start */}
              <div className="overflow-hidden">
                <div
                  id="carouselGWT"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={GWTImage}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Pembersihan GWT 1"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={GWTImage2}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Pembersihan GWT 2"
                      />
                    </div>
                  </div>

                  {/* Navigation Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselGWT"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselGWT"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              {/* images - end */}

              <div className="flex-column align-items-center justify-content-between bg-light p-4">
                <h5 className="mb-3 text-center">Pembersihan GWT</h5>
                <div>
                  <p>
                    Kami menyediakan jasa pemasangan, perawatan , service, dan
                    penjualan filter air untuk berbagai kebutuhan, mulai dari
                    rumah tinggal, kost, kantor, hingga tempat usaha. Selain itu
                    kami juga menyediakan perawataan ground water tank (gwt)
                  </p>

                  {/* list - start */}
                  <div className="mt-1 ps-4">
                    <p className="mb-1">
                      <strong>Layanan meleputi:</strong>
                    </p>
                    <ul>
                      <li>Perawatan ground water tank dan roof water tank</li>
                      <li>Pemasangan sistem filter air</li>
                      <li>Penggantian media filter</li>
                      <li>Service dan perawatan unit filter</li>
                      <li>Penjualan unit filter air</li>
                      <br />
                    </ul>
                  </div>
                  {/* list - end */}
                </div>
              </div>
            </div>
            {/* card - cleaning gwt - end */}

            {/* card - plumbing repair - start */}
            <div
              className="col-lg-4 col-md-6 service-item-top wow fadeInUp"
              data-wow-delay="0.3s"
            >
              {/* images - start */}
              <div className="overflow-hidden">
                <div
                  id="carouselPlumbing"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={PipaImage}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Perbaikan Pipa"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={PipaImage2}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Service Pompa"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={PipaImage3}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Instalasi Air"
                      />
                    </div>
                  </div>

                  {/* Controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselPlumbing"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselPlumbing"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              {/* images - end */}

              <div className="flex-column align-items-center justify-content-between bg-light p-4">
                <h5 className="mb-3 text-center">Perbaikan Pipa Air</h5>
                <div>
                  <p>
                    Kami melayani jasa service, perawatan, pemasangan, dan
                    penjualan mesin pompa air untuk kebutuhan rumah tangga
                    maupun Bangunan bertingkat.
                  </p>

                  {/* list - start */}
                  <div className="mt-1 ps-4">
                    <p className="mb-1">
                      <strong>Layanan meleputi:</strong>
                    </p>
                    <ul>
                      <li>Perbaikan pompa air</li>
                      <li>Wirring System Pompa</li>
                      <li>Gulung dinamo</li>
                      <li>Ganti pressure switch / otomatis</li>
                      <li>Bongkar pasang pompa air</li>
                      <li>Penjualan unit pompa air baru</li>
                    </ul>
                  </div>
                  {/* list - end */}
                </div>
              </div>
            </div>
            {/* card - plumbing repair - end */}

            {/* card - machine repair - start */}
            <div
              className="col-lg-4 col-md-6 service-item-top wow fadeInUp"
              data-wow-delay="0.3s"
            >
              {/* images - start */}
              <div className="overflow-hidden">
                <div
                  id="carouselGenset"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  {/* Indikator Gambar (Opsional) */}
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={MesinImage}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Genset Service 1"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={MesinImage2}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Genset Service 2"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={MesinImage3}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Genset Service 3"
                      />
                    </div>
                  </div>

                  {/* Navigasi Tombol */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselGenset"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselGenset"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              {/* images - end */}

              <div className="flex-column align-items-center justify-content-between bg-light p-4">
                <h5 className="mb-3 text-center">Perbaikan Mesin</h5>
                <div>
                  <p>
                    Kami menyediakan jasa service, perawatan, pemasangan, dan
                    penjualan mesin genset untuk kebutuhan rumah tangga,
                    komersial, hingga industri.
                  </p>

                  {/* list - start */}
                  <div className="mt-1 ps-4">
                    <p className="mb-1">
                      <strong>Layanan meliputi:</strong>
                    </p>
                    <ul>
                      <li>Pemeriksaan dan diagnosa genset</li>
                      <li>Service genset mati atau tidak stabil</li>
                      <li>Penggantian sparepart</li>
                      <li>Perawatan rutin dan berkala</li>
                      <li>Pemasangan genset baru</li>
                      <li>Penjualan mesin genset sesuai kebutuhan</li>
                    </ul>
                  </div>
                  {/* list - end */}
                </div>
              </div>
            </div>
            {/* card - machine repair - end */}

            {/* card - machine sell - start */}
            <div
              className="col-lg-4 col-md-6 service-item-top wow fadeInUp"
              data-wow-delay="0.3s"
            >
              {/* images - start */}
              <div className="overflow-hidden">
                <div
                  id="carouselSell"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  {/* Indikator Gambar (Opsional) */}
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={SaleImage}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Genset Service 1"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src={SaleImage2}
                        className="d-block w-100 h-100 img-fluid"
                        alt="Genset Service 2"
                      />
                    </div>
                  </div>

                  {/* Navigasi Tombol */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselSell"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselSell"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              {/* images - end */}

              <div className="flex-column align-items-center justify-content-between bg-light p-4">
                <h5 className="mb-3 text-center">Penjualan Mesin</h5>
                <div>
                  <p>
                    Kami melayani penjualan dan jasa berbagai kebutuhan
                    elektronik dan teknik untuk rumah, toko, kantor, gedung, dan
                    proyek.
                  </p>

                  {/* list - start */}
                  <div className="mt-1 ps-4">
                    <p className="mb-1">
                      <strong>Melayani:</strong>
                    </p>
                    <ul>
                      <li>AC</li>
                      <li>Pompa air</li>
                      <li>Komponen kelistrikan</li>
                      <li>Genset</li>
                      <li>Filter air</li>
                      <li>Pipa air</li>
                      <br />
                    </ul>
                  </div>
                  {/* list - end */}
                </div>
              </div>
            </div>
            {/* card - machine repair - end */}
          </div>
        </div>
      </div>
      {/* sercive component - end */}
    </div>
  );
}

export default Services;
